import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'E-Commerce',
  subtitle: 'Development',
  tagline: 'Sell More Online',
  // icon: '🛒',
  icon: '',

  heroDesc: 'Launch a powerful, conversion-optimized online store that delivers a seamless shopping experience. We build e-commerce platforms that look great and sell even better.',
  mainStat: '300+',
  mainStatLabel: 'E-commerce & website projects delivered',
  subStats: [{ value: '35%', label: 'Avg Cart Conversion Boost' }, { value: '24/7', label: 'Your Store is Open' }],
  features: [
    { icon: '🛍️', title: 'Custom Store Design', desc: 'Visually stunning, brand-aligned store that customers love to browse.' },
    { icon: '💳', title: 'Payment Gateway', desc: 'Integration with Razorpay, PayU, PayPal, UPI, and all major payment methods.' },
    { icon: '📦', title: 'Inventory Management', desc: 'Powerful backend to manage products, stock, variants, and categories easily.' },
    { icon: '📱', title: 'Mobile Commerce', desc: 'Fully optimized mobile shopping experience — where most customers shop.' },
    { icon: '🔍', title: 'Product SEO', desc: 'SEO-optimized product pages to rank on Google and drive organic sales.' },
    { icon: '📊', title: 'Analytics Dashboard', desc: 'Detailed sales analytics, customer behavior insights, and reporting.' },
  ],
  benefits: [
    { title: 'Sell 24/7 Without Staff', desc: 'Your online store generates revenue while you sleep — no manual effort required.' },
    { title: 'Reach Customers Nationwide', desc: 'Break geographical barriers and sell to customers across India and beyond.' },
    { title: 'Lower Operating Costs', desc: 'E-commerce significantly reduces overhead compared to physical retail.' },
    { title: 'Data-Driven Growth', desc: 'Detailed analytics help you understand customers and optimize for more sales.' },
  ],
  process: [
    { title: 'Discovery & Planning', desc: 'Product catalog review, platform selection, and feature planning.' },
    { title: 'Design & UX', desc: 'Store design focused on browsing experience and easy checkout flow.' },
    { title: 'Development & Integration', desc: 'Store built with payment gateways, shipping, and all required integrations.' },
    { title: 'Product Upload & Testing', desc: 'Products added and entire purchase flow thoroughly tested.' },
    { title: 'Launch & Training', desc: 'Store goes live with complete training on managing orders and inventory.' },
  ],
  whyChoose: [
    { icon: '💰', title: 'Conversion-Focused', desc: 'Every design decision is made to maximize sales and reduce cart abandonment.' },
    { icon: '🔒', title: 'Secure Transactions', desc: 'PCI-compliant checkout with SSL encryption to protect customer data.' },
    { icon: '📱', title: 'Mobile Optimized', desc: '70%+ of shopping happens on mobile. We build mobile-first stores.' },
    { icon: '📞', title: 'Post-Launch Support', desc: 'Dedicated support to resolve any issues after your store goes live.' },
  ],
  reviews: [
    { name: 'Divya Sharma', role: 'Fashion Brand', text: 'Our online store built by DMS generates ₹5 lakh+ in monthly sales. Beyond expectations!' },
    { name: 'Sanjay Tiwari', role: 'Electronics Retailer', text: 'Perfect store, smooth payments, fast checkout. Our customers love the experience.' },
    { name: 'Hina Siddiqui', role: 'Handmade Crafts', text: 'DMS helped me take my craft business online. Sales went from local to all over India!' },
  ],
  faq: [
    { q: 'Which platform do you use for e-commerce?', a: 'We work with WooCommerce (WordPress), Shopify, and custom builds depending on your needs and budget.' },
    { q: 'Can I manage the store myself after launch?', a: 'Yes! We provide complete training and easy-to-use admin panels so you can manage products and orders yourself.' },
    { q: 'Do you handle product uploads?', a: 'Yes, initial product catalog upload is included. We can also offer ongoing catalog management services.' },
  ],
};

export default function ECommerce() {
  return <ServiceTemplate data={data} />;
}
